import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { endpoints } from 'src/endpoint/endpoints';
import { PazientiService } from '../../service/pazienti.service';
import { DatePipe } from '@angular/common';
import { DateFromTo } from '../../monitoraggio/Model/date-from-to';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-risk-score',
  templateUrl: './risk-score.component.html',
  styleUrls: ['./risk-score.component.scss']
})
export class RiskScoreComponent implements OnInit {

  id$;
  @Input() set id(id) {
    this.id$ = id;
    if (this.id$) {
      //this.getPatient();
    }
  }

  riskPercent;

  nFeatures;

  totalFeature = 50;

  patientId;

  clinicalImpressionList = [];

  prefix = '';

  result = { "n_features": 10, "res": 0, "pred": { "0": 0.9155405783, "1": 0.7844594217 }, "feature_importance": { "fe": -0.12904448560019954, "anterior_basal_septum": 0.0, "posterior_basal_septum": 0.0, "anterior_middle_septum": 0.0, "posterior_middle_septum": 0.0, "anterior_apical_septum": 0.0, "posterior_apical_septum": 0.0, "lower_basal_wall": 0.0, "lateral_lower_basal_wall": 0.0, "lateral_basal_wall": 0.0, "anterior_basal_wall": 0.0, "lower_middle_wall": 0.0, "lateral_lower_middle_wall": 0.0, "lateral_middle_wall": 0.0, "anterior_middle_wall": 0.0, "lower_apical_wall": 0.0, "lateral_posterior_apical_wall": 0.0, "lateral_apical_wall": 0.0, "anterior_apical_wall": 0.0, "protein": -0.10629307266671725, "hba1c": -0.018318205012285455, "hba1c_percentage": -0.01614330254941228, "sodium": 0.0, "antero_posterior_diameter": 0.0, "qt": 0.0, "plax_diameter": -0.013287855225595722, "sivtd": 0.0, "azotemia": 0.04560031530188682, "deceleration_time": 0.0, "pq": 0.0, "ivs": 0.0, "qrs": 0.0, "qt_qtcbaz": -0.0034939319488790773, "p": 0.0, "rr_pp": 0.0, "p_qrs_t": 0.0, "pr": 0.0, "st": 0.0, "ivc_diameters": -0.006789710064684048, "nt": 0.0, "galectina": 0.0, "troponina": -0.010415402671043577, "tnf": 0.013183325936697715 }, "risk": ">15%" };

  input = {
    "values": { "age": 69, "gender": "F", "smoker": "Ogni giorno", "fe": 47, "anterior_basal_septum": "Normocinetico", "posterior_basal_septum": "Normocinetico", "anterior_middle_septum": "Normocinetico", "posterior_middle_septum": "Normocinetico", "anterior_apical_septum": "Normocinetico", "posterior_apical_septum": "Normocinetico", "lower_basal_wall": "Normocinetico", "lateral_lower_basal_wall": "Normocinetico", "lateral_basal_wall": "Normocinetico", "anterior_basal_wall": "Normocinetico", "lower_middle_wall": "Normocinetico", "lateral_lower_middle_wall": "Normocinetico", "lateral_middle_wall": "Normocinetico", "anterior_middle_wall": "Normocinetico", "lower_apical_wall": "Normocinetico", "lateral_posterior_apical_wall": "Normocinetico", "lateral_apical_wall": "Normocinetico", "anterior_apical_wall": "Normocinetico", "protein": 6.84, "hba1c": 48.0, "hba1c_percentage": 6.5, "sodium": 138.7, "antero_posterior_diameter": 34.0, "qt": 0.407, "plax_diameter": 45.8, "sivtd": 12.0, "azotemia": 48, "deceleration_time": 176, "pq": 270, "ivs": "si", "qrs": 136, "qt_qtcbaz": 477, "p": 120, "rr_pp": "75/800", "p_qrs_t": "31/16/43", "pr": 0.176, "st": 0.318, "ivc_diameters": 18.0, "systolic": 180, "total_cholesterol": 193.9, "tnf": 14.12629, "galectina": 0.294311, "troponina": 37.27, "nt": 0.843866 }
  }

  tooltipHtml = `
  <div style="line-height:1.2; font-size:0.85rem;">
    <p style="margin:0 0 4px 0;">La copertura informativa indica quante variabili richieste dal modello sono effettivamente disponibili per questo paziente. 
    <br/> Una copertura bassa può ridurre l’affidabilità della stima.</p>
    <p style="margin:0 0 4px 0;">Le principali variabili che influenzano la stima sono:</p>
    <ul style="margin:0; padding-left:14px;">
      <li style="margin:0;">dati anagrafici</li>
      <li style="margin:0;">dati di laboratorio</li>
      <li style="margin:0;">biomarcatori</li>
      <li style="margin:0;">scheda ecocardiografica</li>
      <li style="margin:0;">scheda elettrocardiografica</li>
    </ul>
  </div>
`;


  labels = {
    fe: "FE (%)",
    anterior_basal_septum: "Setto basale anteriore",
    posterior_basal_septum: "Setto basale posteriore",
    anterior_middle_septum: "Setto medio anteriore",
    posterior_middle_septum: "Setto medio posteriore",
    anterior_apical_septum: "Setto apicale anteriore",
    posterior_apical_septum: "Setto apicale posteriore",
    lower_basal_wall: "Parete basale inferiore",
    lateral_lower_basal_wall: "Parete basale postero lat",
    lateral_basal_wall: "Parete basale laterale",
    anterior_basal_wall: "Parete basale anteriore",
    lower_middle_wall: "Parete medio inferiore",
    lateral_lower_middle_wall: "Parete medio postero lat",
    lateral_middle_wall: "Parete medio laterale",
    anterior_middle_wall: "Parete medio anteriore",
    lower_apical_wall: "Parete apicale inferiore",
    lateral_posterior_apical_wall: "Parete apicale postero lat",
    lateral_apical_wall: "Parete apicale laterale",
    anterior_apical_wall: "Parete apicale anteriore",
    protein: "Proteine (g/dL)",
    hba1c: "HbA1c (mmol/mol)",
    sodium: "Sodio (mmol/L)",
    antero_posterior_diameter: "Diametro antero-posteriore",
    qt: "Intervallo QT (0,35 - 0,42 secondi)",
    plax_diameter: "Diametro PLAX",
    sivtd: "SIVtd",
    azotemia: "Azotemia (umol/L)",
    deceleration_time: "Tempo di decelerazione E (ms)",
    pq: "Intervallo PQ (ms)",
    qrs: "Intervallo QRS (ms)",
    qt_qtcbaz: "Intervallo QT/QTcBaz (ms)",
    p: "Intervallo P (ms)",
    rr_pp1: "Intervallo RR (ms)",
    rr_pp2: "Intervallo PP (ms)",
    p_qrs_t: "Intervallo P (Gradi)",
    p_qrs_t2: "Intervallo QRS (Gradi)",
    p_qrs_t3: "Intervallo T (Gradi)",
    pr: "Intervallo PR (0,16 - 0,20 secondi)",
    st: "Intervallo ST (0,27 - 0,33 secondi)",
    ivc_diameters: "Diametri IVC (mm)",
    nt: "Nt pro bnp",
    galectina: "Galectina",
    troponina: "Troponina T",
    tnf: "Tnf alfa",
    age: "Età",
    gender: "Sesso",
    smoker: "Fumatore"
  };

  get riskBadgeClass(): string {
    if (this.riskPercent < 1) {
      this.prefix = '<';
      this.riskPercent = 1;
    }
    if (this.riskPercent < 10) return 'badge highlight-normal';
    if (this.riskPercent < 25) return 'badge highlight-info';
    if (this.riskPercent < 50) return 'badge highlight-warning';
    if (this.riskPercent < 75) return 'badge highlight-alert';
    return 'badge highlight-alert';
  }


  get riskLabel(): string {
    if (this.riskPercent < 10) return 'Molto basso';
    if (this.riskPercent < 25) return 'Basso';
    if (this.riskPercent < 50) return 'Moderato';
    if (this.riskPercent < 75) return 'Alto';
    return 'Molto alto';
  }

  get features(): any {
    this.patientId = this.pazientiService.getPatientId()
    let res = []
    Object.keys(this.result.feature_importance).forEach(element => {
      if (this.result.feature_importance[element] > 0 && this.labels[element] != undefined) {
        res.push(this.labels[element]);
      }
    });

    return res;
  }

  visible = false;

  constructor(private http: HttpClient, private pazientiService: PazientiService, private datePipe: DatePipe, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show("provaSpinner");
    this.visible = false;
    this.patientId = this.pazientiService.getPatientId();
    this.getClinicalImpressionList();
  }

  getClinicalImpressionList() {
    this.http.get(endpoints.clinicalImpressionList + this.patientId).toPromise()
      .then((resp: any) => {
        if (resp && resp.total > 0) {
          resp.entry.forEach((element, index) => {
            const obj: any = {};
            obj.identifier = element.resource.id;
            // tslint:disable-next-line: max-line-length
            obj.date = new Date(this.datePipe.transform(resp.entry[index].resource.date, 'yyyy-MM-dd')).getTime();
            this.clinicalImpressionList.push(obj);
          });
          this.clinicalImpressionList.sort((c1, c2) => c1.date - c2.date)

          console.log("ci list", this.clinicalImpressionList)
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.getRiskScore(this.clinicalImpressionList[0].identifier);
      });
  }

  getRiskScore(clinicalImpressionId) {
    this.http.get(endpoints.getRiskScore + "" + this.patientId + "/" + clinicalImpressionId).toPromise().then((resp: any) => {
      console.log("resp ", resp)
      this.result = resp;
      this.riskPercent = Math.ceil(this.result.pred["1"] * 100);
      this.nFeatures = this.result.n_features;
      this.spinner.hide("provaSpinner");
      this.visible = true;
    }).catch(err => {
      console.error(err);
      this.spinner.hide("provaSpinner");
      this.visible = true;
    });
  }




}
